export class FactoryWorkflow {
	public id			: number;
	public complete		: string;
	public department	: number;

	public constructor(){}
}
